import FlexibleSelect from "./select/FlexibleSelect";
import Select from "./select/Select";

export default function PhoneNumberInput({
  phoneCode,
  phoneNumber,
  setCountryKeyword,
  country,
  countries,
  errorType,
  errorText,
  onChangePhoneCode,
  onChangePhoneNumber,
  required = false,
  searchValue,
}) {
  return (
    <div className="flex flex-col w-full max-w-md">
      {/* <label className="flex items-center gap-1 text-xs font-medium text-text-disabled mb-1 font-CanelaDeck">
        Phone Number
        {required && (
          <span className="text-red-500 text-[8px] mt-[1px]">
            <i className="fa-solid fa-asterisk"></i>
          </span>
        )}
      </label> */}

      {/* <div className="flex gap-1">
        <div className="w-1/3">
          <FlexibleSelect
            isSearch
            onSearchHandler={setCountryKeyword}
            placeholder={"Select country"}
            onChange={onChangePhoneCode}
            selectedValue={phoneCode}
            dropdownData={country?.map((cn) => ({
              name: `${cn?.iso3} (+${cn?.phone_code})`,
              value: cn?.phone_code,
              image: countries?.find((c) => c?.cca3 === cn?.iso3)?.flags?.svg,
            }))}
            searchValue={searchValue}
          />
        </div>
        <div className="w-2/3">
          <input
            type="tel"
            name="phoneNumber"
            placeholder="Enter phone number"
            value={phoneNumber || ""}
            onChange={(e) => onChangePhoneNumber(e)}
            className="w-full h-10 rounded-md placeholder:text-text-disabled bg-white border border-text-secondary/50 px-3 font-CanelaDeck text-sm text-sidebar !ring-0 !outline-0 focus:border-text-disabled transition-all duration-200"
          />
        </div>
      </div> */}
      {errorType && errorType === "error" && (
        <div className="text-xs text-red-600 mt-1">
          <i className="fa-regular fa-fw fa-square-exclamation text-sm mr-1"></i>
          {errorText}
        </div>
      )}
      {errorType && errorType === "warning" && (
        <div className="text-xs text-amber-600 mt-1">
          <i className="fa-regular fa-fw fa-triangle-exclamation text-sm mr-1"></i>
          {errorText}
        </div>
      )}
      {errorType && errorType === "success" && (
        <div className="text-xs text-green-600 mt-1">
          <i className="fa-regular fa-fw fa-circle-check text-sm mr-1"></i>
          {errorText}
        </div>
      )}
      {errorType && errorType === "info" && (
        <div className="text-xs text-sky-600 mt-1">
          <i className="fa-regular fa-fw fa-circle-info text-sm mr-1"></i>
          {errorText}
        </div>
      )}
    </div>
  );
}
